module.exports = {"410526001":"道口镇街道","410526002":"城关街道","410526003":"锦和街道","410526102":"白道口镇","410526103":"留固镇","410526104":"上官镇","410526105":"牛屯镇","410526106":"万古镇","410526107":"高平镇","410526108":"王庄镇","410526109":"老店镇","410526110":"慈周寨镇","410526111":"焦虎镇","410526112":"四间房镇","410526113":"八里营镇","410526114":"赵营镇","410526115":"半坡店镇","410526200":"枣村乡","410526204":"大寨乡","410526205":"桑村乡","410526206":"老爷庙乡","410526209":"瓦岗寨乡","410526212":"小铺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410526.json
// module id = 1572
// module chunks = 0